module.exports = __webpack_public_path__ + "static/pilcrow-1316564aaca99c34bf4455419307f6c2.png";